import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { ReactNode } from 'react';
import { sharedStyles } from '../../utils/Style';
import { useLocalizedText } from '../../hooks/useLocalizedText';

interface ConfirmDialogProps {
  title?: string;
  content: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  color: 'primary' | 'error';
  children?: ReactNode;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const t = useLocalizedText();

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>{props.title ?? 'Emin misiniz?'}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.content}</DialogContentText>
        {props.children ?? []}
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          color='inherit'
          onClick={props.onClose}
          sx={sharedStyles.buttonText}
        >
          {t('confirm_dialog.cancel')}
        </Button>
        <Button
          variant='contained'
          onClick={props.onConfirm}
          autoFocus
          color={props.color}
          sx={sharedStyles.buttonText}
        >
          {t('confirm_dialog.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
